import * as React from "react";
import type { SVGProps } from "react";
const SvgIconRadioActive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_8703_24234)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.4.45q-2.2.2-3.97 1.5c-.65.5-1.27 1.15-1.73 1.84C1.07 4.73.65 5.85.5 6.97.4 7.59.4 8.4.5 9.03c.15 1.12.57 2.23 1.2 3.17.55.82 1.28 1.55 2.1 2.1.96.64 2.1 1.07 3.23 1.21.75.1 1.57.07 2.31-.06.54-.1 1.22-.3 1.74-.53.16-.07.53-.26.71-.37 1.12-.64 2.12-1.64 2.77-2.76q1-1.76 1-3.8c0-.82-.1-1.55-.35-2.32q-.32-.98-.88-1.83C13.78 3 13.04 2.26 12.2 1.7 11.26 1.07 10.15.65 9.03.5 8.6.44 7.83.4 7.41.45m.18 4c-.85.11-1.6.5-2.17 1.1q-.76.82-.94 1.92c-.04.26-.04.8 0 1.06.25 1.56 1.44 2.76 3 3 .26.04.8.04 1.06 0 1.56-.24 2.76-1.44 3-3 .04-.26.04-.8 0-1.06-.24-1.55-1.44-2.76-2.99-3-.22-.03-.74-.04-.96-.02"
        fill="#5C5CFF"
      />
    </g>
    <defs>
      <clipPath id="clip0_8703_24234">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconRadioActive;
